import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "@babel/runtime/helpers/esm/get";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { LoginManager, miloCore } from '@tencent/milo-core';
import GlobalManager, { setLoginManager, setUnLoginCallback } from '../global';
import { _$ } from '../util/domHelper';

var LoginComp = /*#__PURE__*/function (_LoginManager) {
  _inherits(LoginComp, _LoginManager);

  var _super = _createSuper(LoginComp);

  function LoginComp() {
    var _this;

    var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, LoginComp);

    _this = _super.call(this, option);
    _this.opt = _objectSpread(_objectSpread({
      plat: 'pc',
      // 终端，可以选pc/mobile，默认pc

      /**
        *  /0 代表640*640大小的图片
        *  /46 代表46*46大小的图片
        *  /64 代表64*64大小的图片
        *  /96 代表96*96大小的图片
        *  /132 代表133*132大小的图片
      */
      wxAvartarSize: /^(0|46|64|96|132)$/.test(option.wxAvartarSize) ? option.wxAvartarSize : 64
    }, option), {}, {
      oBtns: _objectSpread({
        loginedDiv: 'logined',
        // 登陆显示区DIV的ID
        unloginDiv: 'unlogin',
        // 注销显示区DIV的ID
        userinfoSpan: 'milo_userinfo',
        // 显示用户登陆信息等的ID
        userheadimg: 'milo_headimg',
        // 显示用户的头像的img标签
        logout: 'logoutBtn',
        // 注销按钮
        qq: 'qqLoginBtn',
        // pt QQ登录
        qc: 'qcLoginBtn',
        // 互联登录
        wx: 'wxLoginBtn',
        // 微信登录
        wg: 'wgLoginBtn',
        // wegame登录
        qqwx: 'qqwxLoginBtn',
        // qqwx联合登录
        qcwx: 'qcwxLoginBtn'
      }, option.oBtns)
    });

    _this.initLoginAreaEvent(); // 按钮绑定事件


    setLoginManager(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(LoginComp, [{
    key: "setGlobalUnLogin",
    value: function setGlobalUnLogin(cb) {
      var self = this;
      setUnLoginCallback(function () {
        self.renderLoginArea({
          isLogin: false
        });
        cb();
      });
    }
  }, {
    key: "setOption",
    value: function setOption(opt) {
      this.opt = _objectSpread(_objectSpread({}, this.opt), opt);

      _get(_getPrototypeOf(LoginComp.prototype), "setOption", this).call(this, opt);
    }
  }, {
    key: "initLoginAreaEvent",
    value: function initLoginAreaEvent() {
      var _this2 = this;

      var _this$opt = this.opt,
          oBtns = _this$opt.oBtns,
          logoutCallback = _this$opt.logoutCallback,
          qqOpt = _this$opt.qqOpt,
          wxOpt = _this$opt.wxOpt,
          qcOpt = _this$opt.qcOpt,
          wgOpt = _this$opt.wgOpt,
          qqwxOpt = _this$opt.qqwxOpt,
          qcwxOpt = _this$opt.qcwxOpt;

      var _ref = oBtns || {},
          logout = _ref.logout,
          qq = _ref.qq,
          qc = _ref.qc,
          wx = _ref.wx,
          wg = _ref.wg,
          qqwx = _ref.qqwx,
          qcwx = _ref.qcwx; // 注销


      if (_$(logout)) {
        _$(logout).onclick = function () {
          _this2.logout(logoutCallback);
        };
      } // qq登录


      if (_$(qq)) {
        _$(qq).onclick = function () {
          _this2.loginByQQ(qqOpt);
        };
      } // wx登录


      if (_$(wx)) {
        _$(wx).onclick = function () {
          _this2.loginByWX(wxOpt);
        };
      } // qc登录


      if (_$(qc)) {
        _$(qc).onclick = function () {
          _this2.loginByQQConnect(qcOpt);
        };
      } // wegame登录


      if (_$(wg)) {
        _$(wg).onclick = function () {
          _this2.loginByWegame(wgOpt);
        };
      } // qqwx


      if (_$(qqwx)) {
        _$(qqwx).onclick = function () {
          _this2.loginByQQAndWX(qqwxOpt);
        };
      } // qcwx


      if (_$(qcwx)) {
        _$(qcwx).onclick = function () {
          _this2.loginByQQConnectAndWX(qcwxOpt);
        };
      }
    }
  }, {
    key: "renderLoginArea",
    value: function renderLoginArea(_ref2) {
      var isLogin = _ref2.isLogin,
          userInfo = _ref2.userInfo;
      var _this$opt$oBtns = this.opt.oBtns,
          loginedDiv = _this$opt$oBtns.loginedDiv,
          unloginDiv = _this$opt$oBtns.unloginDiv,
          userinfoSpan = _this$opt$oBtns.userinfoSpan,
          userheadimg = _this$opt$oBtns.userheadimg;

      if (isLogin) {
        _$(loginedDiv) && (_$(loginedDiv).style.display = 'block');
        _$(unloginDiv) && (_$(unloginDiv).style.display = 'none');
        _$(userheadimg) && _$(userheadimg).setAttribute('src', userInfo.avatarUrl);
        _$(userinfoSpan) && (_$(userinfoSpan).innerHTML = miloCore.xss.filterWxNickName(userInfo.nickName || userInfo.userUin || ''));
      } else {
        _$(loginedDiv) && (_$(loginedDiv).style.display = 'none');
        _$(unloginDiv) && (_$(unloginDiv).style.display = 'block');
      }
    }
  }, {
    key: "checkLogin",
    value: function checkLogin(onSuccess, onFail) {
      var _this3 = this;

      var self = this;
      var wxAvartarSize = self.opt.wxAvartarSize;
      return new Promise(function (resolve, reject) {
        _get(_getPrototypeOf(LoginComp.prototype), "checkLogin", _this3).call(_this3).then(function (res) {
          var userInfo = res.userInfo;

          if (userInfo && userInfo.acctype === 'wx') {
            if (userInfo.avatarUrl) {
              userInfo.avatarUrl = userInfo.avatarUrl.replace('/0', "/".concat(wxAvartarSize));
            }
          }

          self.renderLoginArea({
            isLogin: true,
            userInfo: userInfo
          });
          onSuccess && onSuccess({
            isLogin: true,
            userInfo: userInfo
          });
          resolve({
            isLogin: true,
            userInfo: userInfo
          });
        })["catch"](function (err) {
          if (GlobalManager.customizeUnLogin) {
            GlobalManager.unLoginCallback(err);
          } else {
            self.renderLoginArea({
              isLogin: false
            });
          }

          onFail && onFail({
            isLogin: false,
            err: err
          });
          reject({
            isLogin: false,
            err: err
          });
        });
      });
    }
  }, {
    key: "checkRealLogin",
    value: function checkRealLogin(onSuccess, onFail) {
      var _this4 = this;

      var self = this;
      var wxAvartarSize = self.opt.wxAvartarSize;
      return new Promise(function (resolve, reject) {
        _get(_getPrototypeOf(LoginComp.prototype), "checkRealLogin", _this4).call(_this4).then(function (res) {
          var userInfo = res.userInfo;

          if (userInfo && userInfo.acctype === 'wx') {
            if (userInfo.avatarUrl) {
              userInfo.avatarUrl = userInfo.avatarUrl.replace('/0', "/".concat(wxAvartarSize));
            }
          }

          self.renderLoginArea({
            isLogin: true,
            userInfo: userInfo
          });
          onSuccess && onSuccess({
            isLogin: true,
            userInfo: userInfo
          });
          resolve({
            isLogin: true,
            userInfo: userInfo
          });
        })["catch"](function (err) {
          if (GlobalManager.customizeUnLogin) {
            GlobalManager.unLoginCallback(err);
          } else {
            self.renderLoginArea({
              isLogin: false
            });
          }

          onFail && onFail({
            isLogin: false,
            err: err
          });
          reject({
            isLogin: false,
            err: err
          });
        });
      });
    }
  }, {
    key: "initCallback",
    value: function initCallback(opt) {
      var _this5 = this;

      var self = this;

      var option = _objectSpread(_objectSpread(_objectSpread({}, self.opt), opt), {}, {
        callback: opt.callback ? function (res) {
          _this5.isLogin = res.isLogin;
          _this5.userInfo = res.userInfo;

          var _ref3 = res || {},
              isLogin = _ref3.isLogin,
              userInfo = _ref3.userInfo;

          self.renderLoginArea({
            isLogin: isLogin,
            userInfo: userInfo
          });

          if (opt.callback) {
            opt.callback(res);
          }
        } : undefined
      });

      return option;
    }
  }, {
    key: "logout",
    value: function logout(opt) {
      var _this6 = this;

      var _ref4 = opt || {},
          callback = _ref4.callback,
          jumpUrl = _ref4.jumpUrl;

      _get(_getPrototypeOf(LoginComp.prototype), "logout", this).call(this, opt).then(function () {
        _this6.renderLoginArea({
          isLogin: false,
          userInfo: {}
        }); // if (callback) {
        //   // callback();
        //   this.renderLoginArea({
        //     isLogin: false,
        //     userInfo: {},
        //   });
        // } else {
        //   console.log('未设置logout回调');
        //   // debugger;
        //   // if (jumpUrl) {
        //   //   location.href = jumpUrl;
        //   // } else {
        //   //   location.reload();
        //   // }
        // }

      });
    }
  }, {
    key: "loginByQQ",
    value: function loginByQQ() {
      var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      opt = this.initCallback(opt);

      if (this.opt.plat == 'mobile') {
        _get(_getPrototypeOf(LoginComp.prototype), "mobileLoginByQQ", this).call(this, opt);
      } else {
        _get(_getPrototypeOf(LoginComp.prototype), "loginByQQ", this).call(this, opt);
      }
    }
  }, {
    key: "loginByWX",
    value: function loginByWX() {
      var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      opt = this.initCallback(opt);

      if (this.opt.plat == 'mobile') {
        _get(_getPrototypeOf(LoginComp.prototype), "mobileLoginByWX", this).call(this, opt);
      } else {
        _get(_getPrototypeOf(LoginComp.prototype), "loginByWX", this).call(this, opt);
      }
    }
  }, {
    key: "loginByQQConnect",
    value: function loginByQQConnect() {
      var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      opt = this.initCallback(opt);

      if (this.opt.plat == 'mobile') {
        _get(_getPrototypeOf(LoginComp.prototype), "mobileLoginByQQConnect", this).call(this, opt);
      } else {
        _get(_getPrototypeOf(LoginComp.prototype), "loginByQQConnect", this).call(this, opt);
      }
    }
  }, {
    key: "loginByWegame",
    value: function loginByWegame() {
      var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      opt = this.initCallback(opt);

      if (this.opt.plat == 'mobile') {
        _get(_getPrototypeOf(LoginComp.prototype), "mobileLoginByWegame", this).call(this, opt);
      } else {
        _get(_getPrototypeOf(LoginComp.prototype), "loginByWegame", this).call(this, opt);
      }
    }
  }, {
    key: "loginByQQAndWX",
    value: function loginByQQAndWX() {
      var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      opt = this.initCallback(opt);

      if (this.opt.plat == 'mobile') {
        _get(_getPrototypeOf(LoginComp.prototype), "mobileLoginByQQAndWX", this).call(this, opt);
      } else {
        _get(_getPrototypeOf(LoginComp.prototype), "loginByQQAndWX", this).call(this, opt);
      }
    }
  }, {
    key: "loginByQQConnectAndWX",
    value: function loginByQQConnectAndWX() {
      var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      opt = this.initCallback(opt);

      if (this.opt.plat == 'mobile') {
        opt.iUseQQConnect = 1;

        _get(_getPrototypeOf(LoginComp.prototype), "mobileLoginByQQAndWX", this).call(this, opt);
      } else {
        _get(_getPrototypeOf(LoginComp.prototype), "loginByQQConnectAndWX", this).call(this, opt);
      }
    }
  }]);

  return LoginComp;
}(LoginManager);

export { LoginComp as default };
export var Login = {
  init: function init(option) {
    return new Promise(function (resolve, reject) {
      var instance;

      try {
        instance = new LoginComp(option);
        resolve(instance);
      } catch (e) {
        console.log(e);
        reject({
          errCode: -2,
          errMsg: '登陆模块初始化失败'
        });
      }
    });
  }
};